import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import { EXPORT_VIEWS } from './ExportModalConstants';
import ExportModalHeader from './Components/DefaultExportModal/ExportModalHeader';
import ExportModalContent from './Components/DefaultExportModal/ExportModalContent';
import ExportModalFooter from './Components/DefaultExportModal/ExportModalFooter';
import ChemquoteExportModalHeader from './Components/ChemquoteExportModal/ChemquoteExportModalHeader';
import ChemquoteExportModalContent from './Components/ChemquoteExportModal/ChemquoteExportModalContent';
import ChemquoteExportModalFooter from './Components/ChemquoteExportModal/ChemquoteExportModalFooter';
import DatapointsExportModalHeader from './Components/DatapointsExportModal/DatapointsExportModalHeader';
import DatapointsExportModalContent from './Components/DatapointsExportModal/DatapointsExportModalContent';
import DatapointsExportModalFooter from './Components/DatapointsExportModal/DatapointsExportModalFooter';

import './ExportModal.custom.scss';

function ExportModal(props) {
  const { initialize, close, isChemQuoteExport, currentView, data, formData } = props;
  const history = useHistory();

  useEffect(() => {
    initialize(history);

    return () => {
      // onReset();
      close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data || !formData) {
    return null;
  }

  const resolveComponents = () => {
    if (isChemQuoteExport) {
      return {
        Header: ChemquoteExportModalHeader,
        Content: ChemquoteExportModalContent,
        Footer: ChemquoteExportModalFooter,
      };
    }
    if (currentView === EXPORT_VIEWS.DATAPOINTS) {
      return {
        Header: DatapointsExportModalHeader,
        Content: DatapointsExportModalContent,
        Footer: DatapointsExportModalFooter,
      };
    }
    return {
      Header: ExportModalHeader,
      Content: ExportModalContent,
      Footer: ExportModalFooter,
    };
  };

  const { Header, Content, Footer } = resolveComponents();

  return (
    <GeneralDialogLayout
      selfClose={close}
      className="react-dialogs-scrollable exportModalModal"
      size="md"
      movable={false}
      header={<Header {...props} />}
      footer={<Footer {...props} />}>
      <Content {...props} />
    </GeneralDialogLayout>
  );
}

ExportModal.propTypes = {
  data: PropTypes.object,
  formData: PropTypes.object,
  initialize: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  isChemQuoteExport: PropTypes.bool,
  currentView: PropTypes.oneOf([EXPORT_VIEWS.MAIN, EXPORT_VIEWS.DATAPOINTS]),
};

export default ExportModal;
